import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormPentagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFormPentagon"><Path d="M12 2L21.5106 8.90983L17.8779 20.0902H6.12215L2.48944 8.90983L12 2Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconFormPentagon;
